import { AI_IMAGE_TYPE_OPTIONS } from "../constants";
import { useAiImageStoreShallow } from "../store";
import { AiImagePromptSuggestions } from "./ai-image-prompt-suggestions";

export const AiImageTypes = () => {
  const { setType, showSuggestions, hasPrompt } = useAiImageStoreShallow(
    (s) => ({
      setType: s.setType,
      showSuggestions: s.showSuggestions,
      hasPrompt: !!s.prompt,
    }),
  );

  if (hasPrompt) return null;
  if (showSuggestions) return <AiImagePromptSuggestions />;

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-3">
      {AI_IMAGE_TYPE_OPTIONS.map((type) => (
        <button
          aria-label={type.suggestionLabel || type.label}
          type="button"
          key={type.value}
          onClick={() => setType(type.value)}
          className="tw-flex tw-items-center tw-font-sans tw-text-sm tw-text-blue-800 tw-font-normal hover:tw-bg-blue-100 tw-transition-colors tw-duration-200 tw-justify-center tw-h-8 tw-px-3 tw-bg-blue-50 tw-rounded-[100px]"
        >
          {type.suggestionLabel || type.label}
        </button>
      ))}
    </div>
  );
};
